import React from "react";
import TableCell from "../../../../TableList/TableCell/TableCell";
import TableContainer from "../../../../TableList/TableContainer";
import TableRow from "../../../../TableList/TableRow/TableRow";
import TableSection from "../../../../TableList/TableSection/TableSection";
import LModal from "../../../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../../../common/components/Modals/ModalHeader/ModalHeader";

interface IAsteronMultiBenefitDiscountProps {
    isOpen: boolean;
    onClose: () => void;
}

const AsteronMultiBenefitDiscountModal: React.FC<IAsteronMultiBenefitDiscountProps> = (
    props
) => {
    const { isOpen, onClose } = props;

    return (
        <LModal
            Header={() => (
                <ModalHeader onClose={onClose} title="Asteron Multi-benefit discount" />
            )}
            calcHeightMode="auto"
            width="wide"
            isOpen={isOpen}
            onClose={onClose}>
            {() => (
                <React.Fragment>
                    <h3>Asteron Multi-Benefit Discount</h3>
                    <p>
                        We&apos;ll apply the bundling discounts to Personal Insurance
                        policies that commence on or after 8th August 2016. The discount
                        will be applied to all premiums on the policy other than Kids
                        Cover premiums.
                    </p>
                    <TableContainer>
                        <TableSection>
                            {/* Title */}
                            <TableRow>
                                <TableCell isHeader>Cover Type</TableCell>
                                <TableCell isHeader>Discount</TableCell>
                            </TableRow>
                            {/* 2 Cover */}
                            <TableRow>
                                <TableCell>2 Cover types</TableCell>
                                <TableCell>7.5%</TableCell>
                            </TableRow>
                            {/* 3+ Cover */}
                            <TableRow>
                                <TableCell>3 or more Cover types</TableCell>
                                <TableCell>12.5%</TableCell>
                            </TableRow>
                        </TableSection>
                    </TableContainer>
                    <p>
                        You can only count each type of cover once towards the Bundling
                        discount. The eligible types of cover are:
                    </p>
                    <TableContainer>
                        <TableSection>
                            {/* Title Row */}
                            <TableRow>
                                <TableCell isHeader>Cover Type</TableCell>
                                <TableCell isHeader size="medium">
                                    Eligible Covers
                                </TableCell>
                                <TableCell isHeader>
                                    Minimum Sum Insured / Monthly Benefit
                                </TableCell>
                            </TableRow>
                            {/* Life */}
                            <TableRow>
                                <TableCell>Life</TableCell>
                                <TableCell size="medium">
                                    <ul>
                                        <li>Life Cover</li>
                                    </ul>
                                </TableCell>
                                <TableCell>$100,000</TableCell>
                            </TableRow>
                            {/* Trauma */}
                            <TableRow>
                                <TableCell>Trauma</TableCell>
                                <TableCell size="medium">
                                    <ul>
                                        <li>Trauma Recovery Cover</li>
                                        <li>Cancer Cover</li>
                                    </ul>
                                </TableCell>
                                <TableCell>$25,000</TableCell>
                            </TableRow>
                            {/* TPD */}
                            <TableRow>
                                <TableCell>TPD</TableCell>
                                <TableCell size="medium">
                                    <ul>
                                        <li>TPD Cover</li>
                                    </ul>
                                </TableCell>
                                <TableCell>$100,000</TableCell>
                            </TableRow>
                            {/* Disability */}
                            <TableRow>
                                <TableCell>Disability</TableCell>
                                <TableCell size="medium">
                                    <ul>
                                        <li>Income Protection Cover</li>
                                        <li>Workability Cover</li>
                                        <li>Mortgage and Living Cover</li>
                                    </ul>
                                </TableCell>
                                <TableCell>$1,000 per month</TableCell>
                            </TableRow>
                        </TableSection>
                    </TableContainer>
                </React.Fragment>
            )}
        </LModal>
    );
};

export default AsteronMultiBenefitDiscountModal;
